import getCSRF from '~shared/helpers/getCSRF';
import getDeviceID from '~shared/helpers/getDeviceID';
import platform from '~shared/helpers/getPlatform';
import version from '~shared/helpers/getVersion';

export const buildHeaders = (requestID: string) => {
  const deviceID = getDeviceID();
  const result: Record<string, any> = {
    'Cache-Control': 'max-age=0, no-cache, no-store, must-revalidate',
    'Content-Type': 'application/json',
    'x-request-id': requestID,
    // Platform header here will cue the different lifetimes of tokens that may be
    // issued by the backend. Native apps get much longer sessions than web apps.
    'x-platform': platform,
    'x-app-version': version,
  };
  // Only send x-device-info-id when we have a valid device ID (e.g. not when cookies are disabled on web).
  // Sending null/undefined can cause backend to fail biometric validation or look up the wrong device.
  if (deviceID !== null && deviceID !== undefined) {
    result['x-device-info-id'] = deviceID;
  }

  const CSRFToken = getCSRF();
  if (CSRFToken) {
    result['x-csrf-token'] = CSRFToken;
  }

  return result;
};
